"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var PROPERTY_FETCH_PENDING = exports.PROPERTY_FETCH_PENDING = "PROPERTY_FETCH_PENDING";
var PROPERTY_FETCH_COMPLETE = exports.PROPERTY_FETCH_COMPLETE = "PROPERTY_FETCH_COMPLETE";
var PROPERTY_FETCH_ERROR = exports.PROPERTY_FETCH_ERROR = "PROPERTY_FETCH_ERROR";

var DRAFT_FETCH_PENDING = exports.DRAFT_FETCH_PENDING = "DRAFT_FETCH_PENDING";
var DRAFT_FETCH_COMPLETE = exports.DRAFT_FETCH_COMPLETE = "DRAFT_FETCH_COMPLETE";
var DRAFT_FETCH_ERROR = exports.DRAFT_FETCH_ERROR = "DRAFT_FETCH_ERROR";

var FAILED_TRANSACTION_FETCH_PENDING = exports.FAILED_TRANSACTION_FETCH_PENDING = "FAILED_TRANSACTION_FETCH_PENDING";
var FAILED_TRANSACTION_FETCH_COMPLETE = exports.FAILED_TRANSACTION_FETCH_COMPLETE = "FAILED_TRANSACTION_FETCH_COMPLETE";
var FAILED_TRANSACTION_FETCH_ERROR = exports.FAILED_TRANSACTION_FETCH_ERROR = "FAILED_TRANSACTION_FETCH_ERROR";

var SUCCESS_TRANSACTION_FETCH_PENDING = exports.SUCCESS_TRANSACTION_FETCH_PENDING = "SUCCESS_TRANSACTION_FETCH_PENDING";
var SUCCESS_TRANSACTION_FETCH_COMPLETE = exports.SUCCESS_TRANSACTION_FETCH_COMPLETE = "SUCCESS_TRANSACTION_FETCH_COMPLETE";
var SUCCESS_TRANSACTION_FETCH_ERROR = exports.SUCCESS_TRANSACTION_FETCH_ERROR = "SUCCESS_TRANSACTION_FETCH_ERROR";

var RECEIPT_FETCH_ERROR = exports.RECEIPT_FETCH_ERROR = "RECEIPT_FETCH_ERROR";
var RECEIPT_FETCH_COMPLETE = exports.RECEIPT_FETCH_COMPLETE = "RECEIPT_FETCH_COMPLETE";
var RECEIPT_FETCH_PENDING = exports.RECEIPT_FETCH_PENDING = "RECEIPT_FETCH_PENDING";

var ASSESSMENT_STATUS_ERROR = exports.ASSESSMENT_STATUS_ERROR = "ASSESSMENT_STATUS_ERROR";
var ASSESSMENT_STATUS_COMPLETE = exports.ASSESSMENT_STATUS_COMPLETE = "ASSESSMENT_STATUS_COMPLETE";
var ASSESSMENT_STATUS_PENDING = exports.ASSESSMENT_STATUS_PENDING = "ASSESSMENT_STATUS_PENDING";

var SINGLE_ASSESSMENT_STATUS_ERROR = exports.SINGLE_ASSESSMENT_STATUS_ERROR = "SINGLE_ASSESSMENT_STATUS_ERROR";
var SINGLE_ASSESSMENT_STATUS_COMPLETE = exports.SINGLE_ASSESSMENT_STATUS_COMPLETE = "SINGLE_ASSESSMENT_STATUS_COMPLETE";
var SINGLE_ASSESSMENT_STATUS_PENDING = exports.SINGLE_ASSESSMENT_STATUS_PENDING = "SINGLE_ASSESSMENT_STATUS_PENDING";

var PROPERTY_FETCH_BILL_PENDING = exports.PROPERTY_FETCH_BILL_PENDING = "PROPERTY_FETCH_BILL_PENDING";
var PROPERTY_FETCH_BILL_COMPLETE = exports.PROPERTY_FETCH_BILL_COMPLETE = "PROPERTY_FETCH_BILL_COMPLETE";
var PROPERTY_FETCH_BILL_ERROR = exports.PROPERTY_FETCH_BILL_ERROR = "PROPERTY_FETCH_BILL_ERROR";

var PROPERTY_FETCH_RECEIPT_PENDING = exports.PROPERTY_FETCH_RECEIPT_PENDING = "PROPERTY_FETCH_RECEIPT_PENDING";
var PROPERTY_FETCH_RECEIPT_COMPLETE = exports.PROPERTY_FETCH_RECEIPT_COMPLETE = "PROPERTY_FETCH_RECEIPT_COMPLETE";
var PROPERTY_FETCH_RECEIPT_ERROR = exports.PROPERTY_FETCH_RECEIPT_ERROR = "PROPERTY_FETCH_RECEIPT_ERROR";

var PROPERTY_FETCH_ASSESSMENTS_PENDING = exports.PROPERTY_FETCH_ASSESSMENTS_PENDING = "PROPERTY_FETCH_ASSESSMENTS_PENDING";
var PROPERTY_FETCH_ASSESSMENTS_COMPLETE = exports.PROPERTY_FETCH_ASSESSMENTS_COMPLETE = "PROPERTY_FETCH_ASSESSMENTS_COMPLETE";
var PROPERTY_FETCH_ASSESSMENTS_ERROR = exports.PROPERTY_FETCH_ASSESSMENTS_ERROR = "PROPERTY_FETCH_ASSESSMENTS_ERROR";

var PROPERTY_DOWNLOAD_RECEIPT_PENDING = exports.PROPERTY_DOWNLOAD_RECEIPT_PENDING = "PROPERTY_DOWNLOAD_RECEIPT_PENDING";
var PROPERTY_DOWNLOAD_RECEIPT_COMPLETE = exports.PROPERTY_DOWNLOAD_RECEIPT_COMPLETE = "PROPERTY_DOWNLOAD_RECEIPT_COMPLETE";
var PROPERTY_DOWNLOAD_RECEIPT_ERROR = exports.PROPERTY_DOWNLOAD_RECEIPT_ERROR = "PROPERTY_DOWNLOAD_RECEIPT_ERROR";

var MOHALLA_FETCH_COMPLETE = exports.MOHALLA_FETCH_COMPLETE = "MOHALLA_FETCH_COMPLETE";

var RESET_PROPERTY_STATE = exports.RESET_PROPERTY_STATE = "RESET_PROPERTY_STATE";


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/redux/properties/actionTypes.js
// module id = 1723
// module chunks = 895